export default __webpack_public_path__ + "static/media/Sanathan_Textiles_Limited_RHP.77d30d66.pdf";